import type { CrawlerTaxonomy } from '@prerender/design-system/CrawlerPicker';

import { crawlerCategoryLabel } from '~features/crawler-filter';
import { CATEGORY_TO_CRAWLER_IDS } from './DiscoverabilityCrawlers';

// Every AI Insights crawler is an AI crawler, so grouping them under one
// "AI" header would be noise: a flat list of providers instead.
export const DISCOVERABILITY_CRAWLER_TAXONOMY: CrawlerTaxonomy = {
  typeOrder: [],
  typeOf: () => null,
  typeLabel: (type) => type,
  categoryLabel: crawlerCategoryLabel,
  searchAliases: (category) => CATEGORY_TO_CRAWLER_IDS[category] ?? [],
};
